export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {}
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('文案名称')
        }, {
          max: 5,
          message: this.$t('最多输入') + '5' + this.$t('字符'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    init() {
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.$emit('ok', this.dataFrom.name);
        }
      });
    }
  }
};